export const education = [
  { id: 1, label: "Enter Your Major Title", value: "" },
  { id: 2, label: "University Name", value: "" },
  { id: 3, label: "2020 - 2024", value: "" },
];
